import React from "react";

export type CohesionConfig = {
  monarch: {
    sourceId: string;
    clientToken: string;
  };
  make: {
    sourceKey: string;
    writeKey: string;
  };
};

interface CohesionSnippetProps {
  config: CohesionConfig;
  script: string;
}

export const CohesionSnippet: React.FC<CohesionSnippetProps> = ({ config, script }) => {
  const { monarch, make } = config;

  // Error on build if we do not have the required config for a program.
  if (!monarch?.sourceId || !monarch?.clientToken || !make?.sourceKey || !make?.writeKey) {
    throw new Error(`CohesionSnippet: Missing required configuration values`);
  }

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
      !(function (co, h, e, s, i, o, n) {
        var d = "documentElement";
        var a = "className";
        h[d][a] += " preampjs fusejs";
        n.k = e;
        co._Cohesion = n;
        co._Preamp = { k: s, start: new Date() };
        co._Fuse = { k: i };
        co._Tagular = { k: o };
        [e, s, i, o].map(function (x) {
          co[x] =
            co[x] ||
            function () {
              (co[x].q = co[x].q || []).push([].slice.call(arguments));
            };
        });
        var b = function () {
          var u = h[d][a];
          h[d][a] = u.replace(/ ?preampjs| ?fusejs/g, "");
        };
        h.addEventListener("DOMContentLoaded", function () {
          co.setTimeout(b, 3e3);
          co._Preamp.docReady = co._Fuse.docReady = !0;
        });
      })(window, document, "cohesion", "preamp", "fuse", "tagular", {
        tagular: {
          writeKey: "${make.writeKey}",
          sourceKey: "${make.sourceKey}",
          cookieDomain: window.location.hostname.replace("info.", "."),
          anonymousCookie: "ajs_anonymous_id",
        },
        monarch: {
          token: "${monarch.clientToken}",
          sourceId: "${monarch.sourceId}",
          autoRequest: {
            enabled: true,
            hooks: {
              beforeRun: function (config, done) {
                if (window.newrelic) {
                  window.newrelic.addPageAction('monarch_auto_request', { result: 'success' });
                  window.newrelic.interaction().save();
                }
                done();
              },
            },
            params: {
              writeKey: "${make.writeKey}",
            },
            data: {
              application: "rv_creative",
              callType: "autoRequest",
            },
          },
          cookies: ["two_u_redirect", "two_u_control", "two_u_creative"],
        },
        consent: {
          onetrust: {
            optIn: true,
            enabled: (() => {
              const params = new URLSearchParams(window.location.search);
              const consentCheck = params.get('consentCheck');
              return consentCheck === null ? true : consentCheck.toLowerCase() === 'true';
            })(),
            timeout: 500,
          },
          required: (() => {
            const params = new URLSearchParams(window.location.search);
            const consentCheck = params.get('consentCheck');
            return consentCheck === null ? true : consentCheck.toLowerCase() === 'true';
          })(),
          cookieClassification: "C0002",
        },
      });
      ${script}
    `,
      }}
    ></script>
  );
};
